module.exports = __webpack_public_path__ + "img/reply.98f8aa17.svg";